import React from 'react';
import { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  //   Stack,
  Typography,
} from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers';
import { Grid } from '@mui/material';
import { DateTime } from 'luxon';
import ClearIcon from '@mui/icons-material/Clear';
import TuneIcon from '@mui/icons-material/Tune';
import AddIcon from '@mui/icons-material/Add';
import Multiselect from '../../Common/UI/Multiselect/Multiselect';

const ReportSettingForm = ({ selectedSettingId, setShowSettings }) => {
  const [title, setTitle] = useState(``);
  const [allGroups, setAllGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);

  const handleSaveClick = (event) => {};

  const handleCloseClick = (event) => {
    setShowSettings(false);
  };

  return (
    <>
      <TextField
        size='small'
        fullWidth
        value={''}
        id='outlined-basic'
        label='Название'
        onChange={(e) => setTitle(e.target.value)}
      />
      <Box
        sx={{
          width: '100%',
          border: '1px solid #e0e0e0',
          borderRadius: 1,
          p: 2,
          mt: 2,
        }}
      >
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
          <Typography variant='h6' sx={{ flexGrow: 1 }}>
            Фильтры:
          </Typography>
        </Box>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
          <Grid item sm={11} md={11} xs={11}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id='type-multiple-checkbox-label'>Типы</InputLabel>
              {/* <Select
                  labelId='type-multiple-checkbox-label'
                  id='type-multiple-checkbox'
                  multiple
                  value={selectedTypes}
                  onChange={handleChangeTypes}
                  input={<OutlinedInput label='Типы' />}
                  // renderValue={(selected) => selected.join(', ')}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                  // MenuProps={MenuProps}
                >
                  {allTypes.map((type) => (
                    <MenuItem
                      key={type._id}
                      value={type.title}
                      data-id={type._id}
                    >
                      <Checkbox
                        checked={selectedTypes.indexOf(type.title) > -1}
                      />
                      <ListItemText primary={type.title} />
                    </MenuItem>
                  ))}
                </Select> */}
            </FormControl>
          </Grid>
          <Grid
            item
            sm={1}
            md={1}
            xs={1}
            alignContent={'center'}
            justifyContent={'center'}
            // alignItems={'center'}
          >
            <IconButton aria-label='delete' disabled color='primary'>
              <ClearIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Box>

      <Multiselect
        title='Группировки'
        allItems={allGroups}
        selectedItems={selectedGroups}
        setSelectedItems={setSelectedGroups}
      />

      <Box
        sx={{ display: 'flex', justifyContent: 'space-between', mt: 1, gap: 1 }}
      >
        <Button variant='contained' onClick={handleSaveClick}>
          Сохранить
        </Button>
        <Button variant='contained' onClick={handleCloseClick}>
          Закрыть
        </Button>
      </Box>
    </>
  );
};

export default ReportSettingForm;
